import React from 'react'

const XIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={props.size ?? 16} height={props.size ?? 16} viewBox="0 0 16 16" fill="none">
            <path d="M11.8327 2H13.8774L9.4107 7.08333L14.6654 14H10.5507L7.3287 9.80467L3.64136 14H1.5947L6.3727 8.56333L1.33203 2H5.5507L8.46403 5.83467L11.8327 2ZM11.1154 12.7813H12.2487L4.9347 3.15467H3.7187L11.1154 12.7813Z" fill={props?.color ?? "#404040"} />
        </svg>
    )
}

export default XIcon